import { AxiosError } from 'axios';
import React from 'react';
import { TableActionTypes, TableState } from 'web-library';
import { UseCustomMutationReturn } from '../../../api-refactored/utils/useCustomMutation';
import {
  PostReviewGroupExamRegistrationRequest,
  PostReviewGroupExamRegistrationResponse,
  RegistrationRequestTab,
  usePostReviewGroupExamRegistration,
} from '../../../api-refactored/group-exam-registration/usePostReviewGroupExamRegistration';
import { GenericErrorResponse } from '../../../api-refactored/typings';
import {
  PostGroupExamRegistrationSummaryRequest,
  PostGroupExamRegistrationSummaryResponse,
  usePostGroupExamRegistrationSummary,
} from '../../../api-refactored/group-exam-registration/usePostGroupExamRegistrationSummary';
import { ComponentUsage } from './model';

interface IGetMutateFunctionAndPayload {
  componentUsageFor: ComponentUsage;
  dataTableHandler: {
    tabTableState: TableState;
    tabTableDispatch: React.Dispatch<TableActionTypes>;
  };
  applicationUuid: string;
  registrationRequestTab: RegistrationRequestTab;
}

type TableMutation =
  | UseCustomMutationReturn<
      PostReviewGroupExamRegistrationResponse,
      AxiosError<GenericErrorResponse>,
      PostReviewGroupExamRegistrationRequest,
      unknown
    >
  | UseCustomMutationReturn<
      PostGroupExamRegistrationSummaryResponse,
      AxiosError<GenericErrorResponse>,
      PostGroupExamRegistrationSummaryRequest,
      unknown
    >
  | undefined;

type Payload =
  | PostReviewGroupExamRegistrationRequest
  | PostGroupExamRegistrationSummaryRequest
  | undefined;

interface IMutateFunctionAndPayload {
  tableMutation: TableMutation;
  payload: Payload;
}

const useTabMutation = ({
  componentUsageFor,
  dataTableHandler,
  applicationUuid,
  registrationRequestTab,
}: IGetMutateFunctionAndPayload): IMutateFunctionAndPayload => {
  const { tabTableState, tabTableDispatch } = dataTableHandler;
  const postReviewMutation = usePostReviewGroupExamRegistration({
    defaultOnSuccessInput: {
      getCandidateOrSubjectType: registrationRequestTab,
      tableDispatch: tabTableDispatch,
    },
  });
  const postSummaryMutation = usePostGroupExamRegistrationSummary({
    defaultOnSuccessInput: {
      getCandidateOrSubjectType: registrationRequestTab,
      tableDispatch: tabTableDispatch,
    },
  });
  let tableMutation;
  let payload;

  if (componentUsageFor === ComponentUsage.REVIEW) {
    tableMutation = postReviewMutation;
    payload = {
      applicationUuid,
      apiPathParam: {
        order: tabTableState.order,
        page: tabTableState.page,
        pageSize: tabTableState.size,
      },
      tab: registrationRequestTab,
    } as PostReviewGroupExamRegistrationRequest;
  } else if (componentUsageFor === ComponentUsage.SUMMARY) {
    tableMutation = postSummaryMutation;
    payload = {
      applicationUuid,
      apiPathParam: {
        order: tabTableState.order,
        page: tabTableState.page,
        pageSize: tabTableState.size,
      },
      tab: registrationRequestTab,
      paymentStatus:
        tabTableState.filters && tabTableState.filters.paymentStatus
          ? tabTableState.filters.paymentStatus[0]
          : '',
    } as PostGroupExamRegistrationSummaryRequest;
  }

  return {
    tableMutation,
    payload,
  };
};

export { useTabMutation };
